import { HttpClient } from "@angular/common/http";
import { inject, signal } from "@angular/core";
import { ResolveFn } from "@angular/router";
import { ISubjectDetailsResponse } from "../../../models/isubject-details-response";
import { environment } from "../../../../environments/environment";
import { AlertMessageService } from "../alert-msg/message.service";
import { catchError, of } from "rxjs";

export const subjectResolver: ResolveFn<ISubjectDetailsResponse | undefined> = (route, state) => {
  const subjectSlug = signal(route.paramMap.get("sub") ?? "");
  const curriculumSlug = signal(route.paramMap.get("cur") ?? "");
  const _alertMessageService = inject(AlertMessageService);
  const http = inject(HttpClient);
  
  const request = http
    .get<ISubjectDetailsResponse>(
      `${environment.apiUrl}api/website/subjects/${subjectSlug()}?curriclum_slug=${curriculumSlug()}`,
    )
    .pipe(
      catchError((err) => {
        _alertMessageService.addMsg(err?.error?.msg || "Error loading subjects data");
        return of(undefined);
      }),
    );

  return request;
};
